import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import i18n from "../../../../../constants/i18n";
import getCorePopUpStore from "../../../../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";
import Et3Text from "../../../../et3-text";
import Et3Margin from "../../../../et3-ui/ET3Margin";

const WarningAlertHeaderText = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const aletHeader = getCorePopUpStore().alertHeader.get();

  return (
    <React.Fragment>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className="clickable"
        onClick={() => getCorePopUpStore().closePopUps()}
        style={{
          color: colors.all.red
        }}
      />
      <Et3Margin top={0} bottom={0} left={25} right={0} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={40}
        text={i18n.get(aletHeader)}
        isSpan={false}
        color={colors.all.red}
        style={{}}
      />
      <Et3Margin top={0} bottom={0} left={0} right={25} />
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        className="clickable"
        onClick={() => getCorePopUpStore().closePopUps()}
        style={{
          color: colors.all.red
        }}
      />
    </React.Fragment>
  );
});
export default WarningAlertHeaderText;
